<template>

    <div class="p-inputgroup w-full" style="padding-top: 4px;">

        <span v-if="icon" class="p-inputgroup-addon" style="cursor: default;">
          <i :class="icon"></i>
        </span>

        <div class="w-full">
            <span class="p-float-label">

<!--                <InputText style="padding-right: 30px;" id="itc" v-model="curValue" @change="inputChanged" @keyup="inputChanged"/>-->

                <XDropDown :id="itc" ref="XDropDown"
                           v-model="curValue" :filter="true"
                           :option-label="optionLabel"
                           :option-value="optionValue" :options="options"
                           class="w-full"
                           :placeholder="placeholder"/>

                <label :for="itc" style="cursor: pointer;" @click="labelClick">{{ label }}</label>

            </span>
        </div>

    </div>

</template>

<script>

import XDropDown from "../ComponentsExtends/XDropDown";

export default {
    name: "SearchSelect",
    emits: ['update:modelValue', 'change'],
    props: {
        options: null,
        placeholder: null,
        optionLabel: null,
        optionValue: null,
        modelValue: null,
        label: null,
        icon: {
            default: 'fa fa-fw fa-search',
            type: String,
        },
        showClearButton: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            curValue: this.modelValue,
            itc: null,
        }
    },
    methods: {

        clearInput() {
            this.curValue = null;
            this.$emit('update:modelValue', this.curValue);
            this.$emit('change', this.curValue);
        },

        inputChanged() {
            this.$emit('update:modelValue', this.curValue);
        },
        generateIdTooInput() {
            this.itc = 'i_' + Math.random().toString(36).substring(2);
        },

        labelClick() {
            this.$refs.XDropDown.show();
        },

    },
    watch: {

        curValue() {
            this.$emit('update:modelValue', this.curValue);
            this.$emit('change', this.curValue);
        },

        modelValue: {
            immediate: true,
            async handler(newVal) {
                this.curValue = newVal;
            },
        },

    },
    components: {
        'XDropDown': XDropDown
    }

}
</script>

<style scoped>

</style>